export default __webpack_public_path__ + "static/media/background-home-lg.7cb45504.png";